import type CleverTap from 'clevertap-web-sdk/clevertap';
import { isProduction, isStaging } from './authentication';

let clevertapInstance: CleverTap | null = null;

export const initCleverTap = async () => {
  if (isProduction() || isStaging()) {
    if (clevertapInstance) return clevertapInstance;

    const clevertap = await import('clevertap-web-sdk');
    clevertap.default.init(import.meta.env.VITE_CLEVERTAP_ACCOUNT_ID);
    clevertap.default.setLogLevel(3); // Set debug level to 3 for verbose logging
    clevertapInstance = clevertap.default;
    clevertapInstance.spa = true;
    // clevertapInstance.privacy.push({ optOut: true }); //set the flag to true, if the user of the device opts out of sharing their data
    clevertapInstance.privacy.push({ useIP: true }); //set the flag to true, if the user agrees to share their IP data
    return clevertapInstance;
  } else return null;
};
